import { axios } from '@/utils/request'

/**
 * 仓库列表
 * @param parameter
 * @returns {*}
 */
export function getStoreList (parameter) {
  return axios({
    url: '/store/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改仓库
 * @param parameter
 * @returns {*}
 */
export function editStore (parameter) {
  return axios({
    url: '/store/edit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增仓库
 * @param parameter
 * @returns {*}
 */
export function addStore (parameter) {
  return axios({
    url: '/store/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除仓库
 * @param parameter
 * @returns {*}
 */
export function deleteStore (parameter) {
  return axios({
    url: '/store/delete',
    method: 'post',
    data: parameter
  })
}
